import React, { Suspense, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import PortalPreloader from "../../components/preloader/PortalPreloader";

import DetailsTrip from "../../components/tripDetails/detailsTrip/DetailsTrip";
import Review from "../../components/userReview/review/Review";
import TravelAgencyProfile from "../../components/tripDetails/travelAgencyProfile/TravelAgencyProfile";
import { useDetailsTrip } from "../../components/tripDetails/detailsTrip/hooks/useDetailstrip";

import { usePublicationTracking } from "../../../tracking";

import { ContentCard, Text } from "@zorni/components-lib";

import styles from "./Details.module.css";

export function Details() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tripPublicationId, tripDate } = useParams();

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const nbAdults = Number(query.get("nbAdults") ?? 1);
  const nbChilds = Number(query.get("nbChilds") ?? 0);
  const nbBabies = Number(query.get("nbBabies") ?? 0);

  // Hook custom pour charger les données
  const { loading, error, tripFlight } = useDetailsTrip(tripPublicationId);

  const establishmentId = tripFlight?.tripSummary?.establishmentId;
  usePublicationTracking({
    publicationId: tripPublicationId,
    establishmentId,
    enabled: !loading && !error,
  });

  if (loading) return <PortalPreloader />;

  if (error) {
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <div className={styles.errorCard}>
            <Text variant="xl" weight="bold">
              Oups 😕
            </Text>
            <Text className={styles.errorText}>
              Une erreur est survenue lors du chargement des détails du voyage.
            </Text>

            <div className={styles.errorActions}>
              <button
                className={styles.backBtn}
                type="button"
                onClick={() => navigate(-1)}
              >
                Retour
              </button>

              <button
                className={styles.retryBtn}
                type="button"
                onClick={() => navigate(0)}
              >
                Réessayer
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Suspense fallback={<PortalPreloader />}>
      {/* Page détail « 03 - tripDetails » : les avis et l'agence prennent
          place en fin de colonne principale. */}
      <DetailsTrip
        tripPublicationId={tripPublicationId}
        tripFlight={tripFlight}
        nbAdults={nbAdults}
        nbChilds={nbChilds}
        nbBabies={nbBabies}
        tripDateId={tripDate}
        navigate={navigate}
        publicationId={tripPublicationId}
        establishmentId={establishmentId}
      >
        <ContentCard>
          <Review tripPublicationId={tripPublicationId} establishmentId={establishmentId} embedded />
        </ContentCard>

        <TravelAgencyProfile
          tripPublicationId={tripPublicationId}
          tripReference={tripFlight?.tripSummary?.reference}
          establishmentId={establishmentId}
          embedded
        />
      </DetailsTrip>
    </Suspense>
  );
}

export default Details;
